<ion-card class="unroadworthyBorder ion-no-margin ion-margin-top shadow-none">
  <ion-label class="w-100 d-flex flex-column align-items-center text-center">
    <!-- Unroadworthy status description -->
    <ion-text>
      This
      {{ (vehicleDetails()?.asseT_CATEGORY | titlecase) ?? '--' }}
      was flagged unroadworthy
    </ion-text>

    <!-- Unroadworthy date -->
    <ion-text>
      {{ (vehicleDetails()?.unroadworthY_DATE | formatDate:isMobileApp) ?? '---' }}
    </ion-text>

    <!-- Informational message -->
    <ion-text>
      {{ 'UNROADWORTHY_MSG2' | translate }}
    </ion-text>
  </ion-label>
</ion-card>